<template>
  <div class="user-level-selector">
    <div class="user-level-selector__label">
      <span :class="{'active': dropdownOpen === true}" @click="toggleDropdown()">{{userLevel}}</span> <span :class="{'chevron': dropdownOpen === true}"></span>
    </div>
    <div class="user-level-selector__dropdown" v-if="dropdownOpen === true">
      <p class="title">Select user role <span class="chevron"></span></p>
      <p @click="saveUserLevel('admin')">Administator</p>
      <p @click="saveUserLevel('standard')">Standard User</p>
    </div>
  </div>
</template>

<script>
  import UsersService from '@/services/UsersService.js';

  export default {
    name: 'user-level-selector',

    props: ['user', 'save'],

    data: function () {
      return {
        dropdownOpen: false
      }
    },

    mounted: function() {

    },

    beforeDestroy: function() {

    },

    methods: {
      toggleDropdown: function() {
        if(this.dropdownOpen === true) {
          this.dropdownOpen = false;
        }
        else {
          this.dropdownOpen = true;
        }
      },

      saveUserLevel: function(level) {
        if (this.save != false) {
          UsersService.replace(this.user.id, {permissionsGroup: level})
          .then((res) => {
            this.user.permissionsGroup = level;

            this.dropdownOpen = false;
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          })
        }
        else {
          this.user.permissionsGroup = level;

          this.dropdownOpen = false;
        }
      }
    },

    computed:{
      userLevel: function() {
        if(this.user.permissionsGroup == 'admin') {
          return 'Administrator';
        }
        else if(this.user.permissionsGroup == 'standard') {
          return 'Standard User';
        }

        return 'Select user role';
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .user-level-selector {
    position: relative;

    .user-level-selector__label {
      cursor: pointer;

       > .active {
         color: @brand--primary-color;
       }
    }

    .user-level-selector__dropdown {
      position: absolute;
      top: -2rem;
      left: -2rem;
      z-index: 1;
      width: 16.5rem;
      padding: 3rem 2rem;
      border: 1px solid @brand__grey2;
      border-radius: 1rem;
      background-color: #fff;
      box-shadow: 0 0 14px 3px rgba(0,0,0,0.05);

      p.title {

        color: @brand--primary-color;

        .chevron {
          display: inline-block;
          width: 0.75rem;
          height: 0.75rem;
          margin-left: 1rem;
          border-right: 0.125rem solid @brand--primary-color;
          border-bottom: 0.125rem solid @brand--primary-color;
          transform: rotate(45deg) translate(0, -0.3rem);
        }
      }

      p.label {

        .chevron {
          display: inline-block;
          border-right: 0.125rem solid @brand--primary-color;
          border-bottom: 0.125rem solid @brand--primary-color;
          width: 1rem;
          height: 1rem;
          transform: rotate(45deg);
        }
      }

      p {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UserLevelSelector.vue?46d2e526